import { createAction } from '@reduxjs/toolkit';
const FETCH_TEACHER_DASHBOARD_OVERVIEW = 'FETCH_TEACHER_DASHBOARD_OVERVIEW';
const FETCH_DASHBOARD_SUBMODULE_STUDENT_STATUS = 'FETCH_DASHBOARD_SUBMODULE_STUDENT_STATUS';
const TEACHER_DASHBOARD_CLASS_CHANGE = 'TEACHER_DASHBOARD_CLASS_CHANGE';
const TEACHER_DASHBOARD_MODULE_CHANGE = 'TEACHER_DASHBOARD_MODULE_CHANGE';
export const fetchTeacherDashboardOverview = createAction(FETCH_TEACHER_DASHBOARD_OVERVIEW);
export const fetchDashboardSubmoduleStudentStatus = createAction(FETCH_DASHBOARD_SUBMODULE_STUDENT_STATUS);
export const teacherDashboardClassChange = createAction(TEACHER_DASHBOARD_CLASS_CHANGE);
export const teacherDashboardModuleChange = createAction(TEACHER_DASHBOARD_MODULE_CHANGE);